// crewbit-admin/src/lib/scheduleVocabulary.ts
//
// Schedule vocabulary — universal post-Phase-2. The Industry Engine rebuild's
// 2026-05-22 founder call rejected the dialect axis; the 17-entry industry
// map was flattened to the FALLBACK set (spec §6 D-vocab: cluster-true surface
// words stay, arbitrary synonyms flatten).
//
// Mobile + admin file bodies byte-equivalent (per
// feedback_admin_pair_must_match_mobile_body.md).

export interface ScheduleVocabulary {
  /** Singular noun in lowercase ("appointment" / "stop" / "visit" / ...). Used for inline copy. */
  entrySingular: string;
  /** Plural form. Used for counts + lists ("3 appointments today"). */
  entryPlural: string;
  /** Primary CTA label ("Add appointment" / "Add stop"). Used on Add-to-Schedule button. */
  primaryAction: string;
  /** EmptyState body copy ("No appointments booked" / "No stops scheduled today"). */
  emptyMessage: string;
  /** Detail-sheet "add similar" or "add follow-up" label ("Add another appointment"). */
  addLabel: string;
}

const FALLBACK: ScheduleVocabulary = {
  entrySingular: 'entry',
  entryPlural: 'entries',
  primaryAction: 'Add to Schedule',
  emptyMessage: 'Nothing scheduled.',
  addLabel: 'Add another',
};

/**
 * Resolve schedule vocabulary. Phase 2 flattened the per-industry map to the
 * universal FALLBACK — `_industry` is preserved on the signature for additive
 * future use (and so existing callsites don't have to change). Returns the
 * FALLBACK set for every input.
 */
export function resolveScheduleVocabulary(_industry: string | null | undefined): ScheduleVocabulary {
  return FALLBACK;
}
